<h1>Campaign Central Policies</h1>
<div class="mx-auto mt-1 mb-5" style="width: 800px;">
  <h2>iconectiv Confidential - Restricted Access</h2>
  <a id="restrictedaccess"></a> 
  <p>
    This product and any exports or printouts and the confidentiall information they contain shall be made available
    solely to authorized persons having a need to know within iconectiv, except with written permission of iconectiv.
  </p>
  <p class="text-center">
    Telcordia Technologies, Inc. dba iconectiv
  </p>
  <h2>Privacy Policy</h2>
  <a id="privacypolicy"></a> 
  <p>
    Telcordia Technologies, Inc. d/b/a iconectiv (“iconectiv” or “we”) respects your privacy. Therefore, we have developed state-of-the
    art privacy programs to ensure the security and protection of the data that we collect through the provision of our mission-critical
    services.
  </p>
  <p>
    Because we gather certain types of information about the users who visit our website or use our services, we believe you
    should fully understand the terms and conditions surrounding the use of the information we collect. Please review the
    following statement to understand how the information you provide to iconectiv will be treated.
  </p>
  <h3>1. Information iconectiv Collects</h3>
  <p>
    You are free to visit iconectiv’s website without identifying yourself. However, if you would like more information regarding
    our products and services, you may be required to first register with iconectiv. When you register, we will request certain
    business information, including your name, address, and email address. This information will enable iconectiv to contact
    you regarding the products and services provided, as well as provides us with aggregate demographic data that iconectiv
    uses to improve the services offered to users. In connection with registering for certain services, you may be asked
    a series of questions relating to you, your company and your intended uses of such services. iconectiv may from time
    to time request personal information for purposes such as the provision of customer service, network management, surveys,
    offers of related services, and other exchanges of information. Finally, we gather information about all users collectively,
    such as what areas users visit most frequently and what services users access most often. We automatically log IP addresses,
    session sources, and other data which tracks users' access to our website. We analyze these logs in order to understand
    aggregate user behavior as well as to monitor system performance. These logs are analyzed for the overall, aggregate
    trends they reveal about our customers, not for individual user behaviors.
  </p>
  <h3>2. What iconectiv Does With the Information It Collects</h3>
  <p>
    In submitting data in an application for a particular service, you are hereby granting iconectiv, and its designees and agents,
    a license to use, copy, distribute, publish, and modify all of the data contained in your application or submitted thereafter
    ( "Data") for the purposes of implementing this and other related services, processing your application, notifying you
    of changes to the service for archival purposes, and creating and using aggregate information about the use of such service
    (s) wherein identifying information about you has been removed. Except as otherwise provided in this Privacy Policy,
    information you supply to iconectiv will not be given, sold, rented, loaned, or otherwise disclosed to any third parties
    outside of iconectiv, except when we have your express permission or under special circumstances, such as when we believe
    in good faith that disclosure is reasonably necessary to (i) comply with legal process or in compliance with applicable
    laws, (ii) enforce the service terms and conditions, or (iii) protect the rights, property, or personal safety of iconectiv,
    its customers, or the public. iconectiv may use aggregated Data (including derived data) to determine the demographics
    of our users, and to distribute statistics and general marketplace information about iconectiv. These demographics will
    always represent aggregate information and will never identify specific users. Certain non-personal information regarding
    users is recorded by the operation of the internet servers hosting the iconectiv sites. Additionally, we may disclose
    aggregated user statistics to prospective partners, advertisers, and other third parties, and may otherwise use and provide
    such Data (including derived data) on an aggregated basis to third parties, for any lawful purposes.
  </p>
  <h3>3. What is a cookie</h3>
  <p>
    A cookie is a small data file that certain websites write to your hard drive when you visit them. A cookie file can contain
    information that allows a website to track the pages you've visited. But the only personal information a cookie can
    contain is information you supply yourself. A cookie can't read data off your hard disk or read cookie files created
    by other sites. We use cookies to tell when a user is a repeat visitor and to let us know how the user found the site.
    They also allow us to automatically link users to their personalized accounts. When you create an account, we use a cookie
    to store a unique, random code. We only use this code to identify you anonymously in our database and to track the pages
    you visit on our site. This helps us better understand and improve areas of the site that our users find valuable. We
    also use this code to enable you to enter various services as a member, and to visit member-restricted areas of the site
    without having to log in each time. If you've set your browser to warn you before accepting cookies, you will receive
    the warning message with each cookie. Though some of the services require the use of cookies, visitors to iconectiv’s
    website always have the option of disabling cookies via their browser preferences. You can refuse cookies by turning
    them off in your browser. However, some of the services will not work if you have cookies disabled.
  </p>
  <h3>4. User Options &mdash; Opt-Out</h3>
  <p>
    From time to time, we may notify our customers of new products, announcements, upgrades and updates. Users may opt out of
    receiving these future promotional mailings by filling out the form on http://www.iconectiv.com/iforms/subscribe.php or
    by contacting us at our mailing address:</p>
  <address>
    <strong>iconectiv</strong>
    <br>100 Somerset Corporate Blvd.
    <br>Bridgewater, NJ 08807
    <br>Attn: Legal
    <br>email: info&#64;iconectiv.com
  </address>
  <p>
    iconectiv reserves the right to send users email related to business practices and systems operations, such as outage notifications
    and quota warnings, even if the user has opted out of promotional mailings.
  </p>
  <h3>5. Provision of Unsolicited Information</h3>
  <p>iconectiv appreciates your feedback and suggestions. Our goal is to provide all our customers with high quality products
    and services. iconectiv's ability to freely evaluate and, if appropriate, implement ideas and information improves the
    online experience for all users. Therefore, any information, feedback, questions, comments, suggestions, or any
    other material, submitted to iconectiv, whether solicited or unsolicited, regarding its software, website or technology
    shall be deemed non-confidential. By providing any such material, you grant iconectiv an unrestricted, irrevocable, royalty-free,
    and perpetual right to freely, reproduce, use, disclose, modify, perform, publish, translate, create derivative works
    from, distribute, and display any such information you send iconectiv, without limitation, for any and all commercial
    and non-commercial purposes. We are free to use any ideas, concepts or techniques contained in this response for any
    purpose whatsoever including, but not limited to, developing, manufacturing, and marketing products incorporating such
    ideas, concepts or techniques.
  </p>
  <h3>6. iconectiv Privacy Statement Changes</h3>
  <p>
    If iconectiv changes this privacy statement, we will post those changes at http://www.iconectiv.com so that you will always
    know what information we gather, how we might use that information, and whether we will disclose it to anyone. By using
    our services, you signify your assent to the iconectiv Privacy Statement. If you do not agree to this statement, please
    do not use the iconectiv website or its services. Your continued use of the iconectiv service following the posting
    of changes to these terms will mean you accept those changes.
  </p>
  <h3>7. Contact iconectiv</h3>
  <p>
    If you have any questions about this privacy statement or this website, please contact:
  </p>
  <address>
    <strong>iconectiv</strong>
    <br>100 Somerset Corporate Blvd.
    <br>Bridgewater, NJ 08807
    <br>Attn: Legal
    <br>email: info&#64;iconectiv.com
  </address>
</div>
